import Vue from "vue";
import { gameStore } from "../store/game/store";
import { Colors, CardCategory } from '@/store/game';
import _ from 'lodash';
export default Vue.extend({
  data() {
    return {
      cards: [] as {
        off: ThreeState;
        clickable: boolean;
      }[]
    };
  },
  computed: {
    colors() {
      return Colors;
    }
  },
  methods: {
    toggle(index: number) {
      if (!this.cards[index].clickable) return;
      this.cards[index].off = nextThreeStateValue(this.cards[index].off);
    }
  },
  created() {
    const players = gameStore.state.players.length;
    const lastDigit = (n: number) => n.toString().split('').pop()!;
    for (let i = 0; i < 30; i++) {
      let off: ThreeState = 0;
      if (
        (lastDigit(i) == "9" && players < 6) ||
        (lastDigit(i) == "8" && players < 5) ||
        (lastDigit(i) == "7" && players < 4)) {
        off = 2;
      }
      const cardNumber = lastDigit(i),
        category = i < 10 ? CardCategory.Person : i < 20 ? CardCategory.Location : CardCategory.Weapon;
      if (_.some(gameStore.playerSeeableCards, c => c.number.toString() == cardNumber && c.category == category)) off = 2;
      this.cards.push({
        off,
        clickable: !off
      });
    }
  }
});

type ThreeState = 0 | 1 | 2;

function nextThreeStateValue(current: ThreeState) {
  return <ThreeState>((current + 1) % 3);
}